import React from "react";
import { ChevronRight } from "lucide-react";

import {
  RelatedAs,
  RELATED_AS_LABELS,
} from "../../../api/stakeholder_relationships";

export interface StakeholderItemProps {
  name: string;
  relatedAs: RelatedAs;
  onClick?: () => void;
  className?: string;
}

const getRelationshipLabel = (relatedAs: RelatedAs): string => {
  return RELATED_AS_LABELS[relatedAs];
};

const getRelationshipPillClassName = (
  relatedAs: RelatedAs,
): string => {
  switch (relatedAs) {
    case RelatedAs.PRIMARY_BORROWER:
      return "bg-[#EBEEFE] text-[#3551F3]";

    case RelatedAs.CO_BORROWER:
      return "bg-[#F0F9FF] text-[#0EA5E9]";

    case RelatedAs.GUARANTOR:
      return "bg-[#FEF9C3] text-[#CA8A04]";

    case RelatedAs.DIRECTOR:
    case RelatedAs.PARTNER:
    case RelatedAs.PROPRIETOR:
    case RelatedAs.PROMOTER:
    case RelatedAs.TRUSTEE:
      return "bg-[#DCFCE7] text-[#16A34A]";

    default:
      return "bg-indigo-50 text-indigo-600";
  }
};

const StakeholderItem: React.FC<StakeholderItemProps> = ({
  name,
  relatedAs,
  onClick,
  className = "",
}) => {
  const label = getRelationshipLabel(relatedAs);
  const pillClassName = getRelationshipPillClassName(relatedAs);

  return (
    <button
      type="button"
      onClick={onClick}
      className={`
        flex
        min-w-0
        items-center
        font-[Inter]
        justify-between
        gap-2
        rounded-[8px]
        border
        border-[#E5E5E5]
        bg-white
        p-2
        text-left
        ${className}
      `}
    >
      <span
        className="
          min-w-0
          flex-1
          truncate
          text-[14px]
          font-normal
          leading-[20px]
          text-[#0A0A0A]
        "
      >
        {name}
      </span>

      <span
        className={`
          min-w-0
          max-w-[55%]
          shrink
          truncate
          rounded-[8px]
          border
          border-transparent
          px-2
          py-[2px]
          text-[12px]
          font-medium
          leading-[16px]
          ${pillClassName}
        `}
        title={label}
      >
        {label}
      </span>

      <ChevronRight
        size={16}
        className="shrink-0 text-[#737373]"
      />
    </button>
  );
};

export default StakeholderItem;